import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import _ from 'underscore';
import TarotReadingQuestion from './question';
import TarotReadingShuffle from './shuffle';
import TarotReadingDeck from './deck';
import TarotSampleInterp from './sample-interp';
import TarotSpread from '../tarot-spread';
import ReadingHeaderPrice from '../../reading-header-price';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({accordionOpen: false});
    }

    render({ upc, deck, button_text }) {
        if (deck) {
            return (
                <tarot-reading-teeup>
                    <section>
                        {this.renderSample()}
                        {this.renderSaleMessage()}
                        <header>
                            <ReadingHeaderPrice />
                            <div class={'icon-teeup icon-' + upc} />
                            {this.renderReadingHeader()}
                            {this.renderHeaderP()}
                        </header>
                        {this.renderAside()}
                        <TarotReadingQuestion />
                    </section>
                    <section>
                        <TarotReadingShuffle />
                        {this.renderSpreadH2()}
                        <TarotReadingDeck upc={upc} />
                        {this.renderDeckSelect()}
                    </section>
                    {this.renderCaption()}
                    <TarotSpread />
                    <div class='error'>
                        {this.renderError()}
                    </div>
                    <form onSubmit={this.reveal}>
                        <div class='button-wrapper'>
                            <button
                              class={this.props.completed ? 'button-warning' : 'disabled button-warning'}
                              data-action={
                                  button_text == 'shuffle cards'
                                  ? 'Click-Shuffle-Cards-Button'
                                  : 'Click-Reveal-Meaning-Button'
                              }
                            >
                                {button_text}
                            </button>
                        </div>
                    </form>
                    {this.renderSampleInterps()}
                </tarot-reading-teeup>
            );
        }

        return null;
    }

    renderSample = () => {
        if (this.props.upc.match(/sample/)) {
            return (
                <div>
                    <img
                      class='free-tag'
                      src={'https://gfx.tarot.com/images/site/tarot/' + this.props.upc + '/corner-burst.svg'}
                      alt='FREE!'
                    />
                </div>
            );
        }

        return null;
    }

    renderSaleMessage = () => {
        if (!this.props.upsell_upc) {
            return (
                <sale-message />
            );
        }

        return null;
    }

    renderReadingHeader = () => {
        if (this.props.teeup && this.props.teeup.display_name) {
            return (
                <h1 class='reading-header fancy-title'>{this.props.teeup.display_name}</h1>
            );
        }

        return null;
    }

    renderHeaderP = () => {
        if (this.props.type != 'full' || this.props.sample_interps) {
            return null;
        }

        let subhead = null;

        if (this.props.teeup) {
            if (this.props.teeup.code == 'yes-or-no-tarot-redux') {
                subhead = this.props.teeup.medium_description;
            } else if (this.props.teeup.display_caption) {
                subhead = this.props.teeup.display_caption;
            }

            if (subhead) {
                return (
                    <p>
                        {subhead}
                        {this.renderLearnMoreLink()}
                    </p>
                );
            }
        }

        return null;
    }

    renderLearnMoreLink = () => {
        if (this.props.teeup.long_description) {
            return (
                <a href='#' onClick={this.toggleAccordion} data-action='Click-Learn-More'>
                    &nbsp;Learn More
                </a>
            );
        }

        return null;
    }

    renderAside = () => {
        if (this.state.accordionOpen) {
            return (
                <aside class='details'>
                    <button onClick={this.toggleAccordion}>✕</button>
                    <h3>{this.props.teeup.display_name} description</h3>
                    <summary>
                        {this.props.teeup.long_description.map((section) => (this.renderSummaryP(section)))}
                    </summary>
                    <br />
                    {this.renderCardDescriptions()}
                </aside>
            );
        }

        return null;
    }

    renderCardDescriptions = () => {
        if (
            this.props.upc != 'yes-or-no-tarot-redux'
            &&
            this.props.teeup.positions[0].title
            &&
            this.props.teeup.positions[0].title
        ) {
            return [
                <h3>Card Descriptions</h3>,
                <dl>
                    {this.props.teeup.positions.map((position) => (this.renderPosition(position)))}
                </dl>,
            ];
        }

        return null;
    }

    renderSummaryP = (section) => {
        if (section) {
            return (
                <p dangerouslySetInnerHTML={{__html: section}} />
            );
        }

        return null;
    }

    renderPosition = (position) => {
        if (position.title && position.short_description) {
            return (
                <virtual no-reorder>
                    <dt>{position.title}: </dt>
                    <dd>{position.short_description}</dd>
                    <br />
                </virtual>
            );
        }

        return null;
    }

    renderSpreadH2 = () => {
        if (!this.props.completed) {
            if (this.props.upc == 'yes-or-no-tarot-redux' || !this.props.next_position) {
                return (
                    <h2 class={this.props.picked_cards.length ? 'card-next inactive' : 'card-next'}>
                        Choose card:
                    </h2>
                );
            }

            return (
                <h2 class={this.props.picked_cards.length ? 'card-next inactive' : 'card-next'}>
                    Choose {this.props.next_position.title} card:
                </h2>
            );
        }

        return (
            <h2 class='card-next inactive'>All Cards Chosen</h2>
        );
    }

    renderDeckSelect = () => {
        if (this.props.decks && this.props.deck.type == 'tarot') {
            return (
                <select onChange={this.props.changeDeck}>
                    <option disabled selected>Choose a Deck</option>
                    {this.props.decks.map((deck) => {
                        return deck.type == 'tarot' ? this.renderDeckSelectOption(deck) : null;
                    })}
                </select>
            );
        }

        return null;
    }

    renderDeckSelectOption = (deck) => {
        if (deck) {
            return (
                <option value={deck.code}>{deck.name}</option>
            );
        }

        return null;
    }

    renderCaption = () => {
        if (this.props.type !== 'full' && this.props.teeup && this.props.teeup.display_caption) {
            return (
                <aside class='details-caption text-left'>
                    <p>{this.props.teeup.display_caption}</p>
                </aside>
            );
        }

        return null;
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <p class={this.props.error.remaining ? 'show' : ''}>
                    Please choose {this.props.error.remaining} more&nbsp;
                    {parseInt(this.props.error.remaining, 10) > 1 ? 'cards' : 'card'} from the deck above first.
                </p>
            );
        }

        return null;
    }

    renderSampleInterps = () => {
        if (this.props.sample_interps) {
            return (
                <section>
                    {this.props.positions.map((position, i) => (this.renderSampleInterp(i)))}
                </section>
            );
        }

        return null;
    }

    renderSampleInterp = (i) => {
        if (i) {
            return (
                <TarotSampleInterp i={i} />
            );
        }

        return null;
    }

    reveal = (e) => {
        e.preventDefault();

        if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.completed) {
            if (this.props.deck.spread.length > 8) { //moving from view 1 to view 2
                //set deck.spread to picked_cards (shuffled)
                const cards = _.shuffle(this.props.picked_cards);
                this.props.spread(cards);

                //set tarot-reading.button_text to 'reveal the meaning'
                this.props.buttonText('reveal the meaning');

                //empty tarot-reading.cards
                this.props.cards([]);

                //hide 'choose a deck' select input
                document.querySelector('tarot-reading select').style.display = 'none';

                //set question subject, in new p.subject-set
                const questionP = document.querySelector('tarot-question p.subject'); //old p.subject
                if (questionP) {
                    questionP.style.display = 'none';
                }

                const questionInput = document.querySelector('tarot-question input'); //old question input
                if (questionInput) {
                    questionInput.style.display = 'none';
                }

                //new question p
                const subjectP = document.createElement('p');
                subjectP.classList.add('subject-set');
                subjectP.innerHTML = 'Your Question: ' + this.props.subject;

                //add new question p to tarot-question element
                document.querySelector('tarot-question').appendChild(subjectP);

                //remove subheadline and 'Learn More' link
                document.querySelector('tarot-reading header > p').style.display = 'none';

                return false;
            }
        }

        this.props.fetch();
        return false;
    }

    toggleAccordion = (e) => {
        e.preventDefault();
        this.setState({ accordionOpen: !this.state.accordionOpen });
    }
}

const mapStateToProps = (state) => ({
    button_text: state.product.submitting ? 'submitting…' : state['tarot-reading'].button_text,
    completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
    deck: state.deck,
    decks: state.decks,
    error: state['tarot-reading'].error,
    next_position: state['tarot-reading'].positions[state['tarot-reading'].cards.length],
    picked_cards: state['tarot-reading'].cards,
    positions: state['tarot-reading'].positions,
    sample_interps: state['tarot-reading'].sample_interps,
    teeup: state.product.teeup,
    upsell_upc: state.product.teeup && state.product.teeup.upsell_upc,
    subject: state['tarot-reading'].subject || 'Unspoken',
});

const mapDispatchToProps = (dispatch) => ({
    changeDeck: (e) => dispatch({ type: 'deck:required', payload: e.target.value }),
    fetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    spread: (cards) => dispatch({ type: 'deck:update_spread', payload: cards }),
    buttonText: (text) => dispatch({ type: 'tarot-reading:button_text', payload: text }),
    cards: (cards) => dispatch({ type: 'tarot-reading:cards', payload: cards }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/teeup.js